import React, { Component } from 'react';
import config from '../../../config';
import { connect } from 'react-redux';
import { navigation_close_on_submit } from '../../../redux/reducers/navigationSlice';
import { trimTrailingSlash } from '@emarketer/code-helpers';

import { premiumForecasts } from '../../../redux/reducers/premiumSlice';
import PremiumPopper from '../../PremiumTag/PremiumPopper';

/**
 * TODO:
 * Premium code is left in place under comments for the future use
 */

function mapStateToProps(state, ownProps) {
   return {
      SelectedGeography: state.navigation.selectedGeography
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      onClick: (templateId, SelectedTemplateId) => {
         if (SelectedTemplateId !== templateId) {
            dispatch(navigation_close_on_submit());
         }
      }
   };
};

class HomeTemplateLink extends Component<
   {
      CollectionType: string;
      SelectedTemplateId: string;
      SelectedGeography: string;
      id: string;
      templateid: string;
      name: string;
      channelTitle: string;
      onClick: (templateId: string, SelectedTemplateId: string) => void;
      navToggleClose: () => void;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick(isPremium: boolean) {
      this.props.onClick(this.props.templateid, this.props.SelectedTemplateId);
      window.iiAna('track', 'Forecasts-Index-Link', {
         templateName: this.props.name,
         templateId: this.props.templateid,
         isPremium: isPremium
      });
   }

   public render() {
      const { SelectedGeography, name, channelTitle, id, templateid } = this.props;

      const checkTemplateForPremium = () => {
         return premiumForecasts.some(f => f.collectionId === id);
      };

      const displayPremiumFeatures = () => config.enableNonPremiumFeatures && checkTemplateForPremium();

      // TODO:  this analytics tag is wrong and should be updated to pass in data like we have the rest of the platform
      // const analyticTag = `Forecasts-Navigation-${FormatText(SelectedGeography)}-${FormatText(channelTitle)}-${id}`;
      // const analyticTag = `Forecasts-Home-Link`;
      const templatePath = templateid ? `/${templateid}` : '';
      const url = `${trimTrailingSlash(config.publicPath)}/${id}${templatePath}`;
      // TODO: We need to add the premium visibility octopus bool here and add the premium tag
      return (
         <li>
            <a href={url} onClick={() => this.onClick(checkTemplateForPremium())}>
               {name}
            </a>
            {displayPremiumFeatures() && <PremiumPopper />}
         </li>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeTemplateLink);
